import axios from "axios";

/**
 * Generic function to make POST API calls.
 * @param {string} url - The API endpoint URL.
 * @param {object} [data={}] - The request payload.
 * @param {object} [headers={}] - Optional headers.
 * @returns {Promise<any>} - The API response.
 */
export const postRequest = async (url, data, headers) => {
  try {
    const response = await axios.post(url, data, { headers });
    return response.data;
  } catch (error) {
    console.error("Error in postRequest:", error);
    throw error; // Re-throw error for handling at call site
  }
};
